import { useAppStateAssetPortfolioListStore } from '../../../../common/store/AppStateStore.zustand';
import React, { useState } from 'react';
import { useAssetPortfolioAPI } from '../../api/AssetPortfolio.api';
import { AssetPortfolio } from '../../type/AssetPortfolio.type';
import AddAssetPortfolioModal, { AddAssetPortfolioModalData } from './AddAssetPortfolioModal';
import EditAssetPortfolioModal, { EditAssetPortfolioModalData } from './EditAssetPortfolioModal';

export interface ManageAssetPortfolioModalData {
  isOpen: boolean;
  onClose: () => void;
}

const ManageAssetPortfolioModal = ({ isOpen, onClose }: ManageAssetPortfolioModalData) => {
  const { getAssetPortfolioList, deleteAssetPortfolio } = useAssetPortfolioAPI();
  const { assetPortfolioList, setAssetPortfolioList } = useAppStateAssetPortfolioListStore();
  const [addAssetPortfolioModalData, setAddAssetPortfolioModalData] = useState<AddAssetPortfolioModalData>();
  const [editAssetPortfolioModalData, setEditAssetPortfolioModalData] = useState<EditAssetPortfolioModalData>();

  const handleCloseClick = () => {
    onClose();
  };

  const handleAddClick = () => {
    setAddAssetPortfolioModalData({
      isOpen: true,
      onClose: () => setAddAssetPortfolioModalData(undefined),
    });
  };

  const handleDeleteClick = async (assetPortfolioId: string) => {
    await deleteAssetPortfolio(assetPortfolioId);
    const { data } = await getAssetPortfolioList();
    setAssetPortfolioList(data);
  };

  const handleEditClick = async (assetPortfolio: AssetPortfolio) => {
    setEditAssetPortfolioModalData({
      isOpen: true,
      assetPortfolio: assetPortfolio,
      onClose: () => setEditAssetPortfolioModalData(undefined),
    });
  };

  return isOpen ? (
    <div className="fixed h-screen inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-full max-w-2xl max-h-[80vh] overflow-hidden">
        <div className="p-6 border-b border-gray-200">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-bold text-gray-800">포트폴리오 관리</h2>
            <button onClick={() => handleCloseClick()} className="text-gray-400 hover:text-gray-600">
              <i className="fas fa-times"></i>
            </button>
          </div>
        </div>
        <div className="p-6 overflow-y-auto" style={{ maxHeight: 'calc(80vh - 140px)' }}>
          <div className="mb-6 flex justify-between items-center">
            <p className="text-gray-600">총 {assetPortfolioList.length}개의 포트폴리오가 등록되어 있습니다.</p>
            <button
              onClick={() => handleAddClick()}
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md text-sm flex items-center !rounded-button break-keep"
            >
              <i className="fas fa-plus mr-2"></i> 포트폴리오 추가하기
            </button>
          </div>
          <div className="bg-gray-50 rounded-lg">
            {assetPortfolioList.map((assetPortfolio) => (
              <div key={assetPortfolio.id} className="p-4 border-b border-gray-200 last:border-b-0 hover:bg-gray-100">
                <div className="flex justify-between items-center">
                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-purple-50 rounded-full flex items-center justify-center text-purple-500 mr-3">
                      <i className="fas fa-chart-pie text-purple-300"></i>
                    </div>
                    <div>
                      <h3 className="font-medium text-gray-800">{assetPortfolio.name}</h3>
                      <div className="flex items-center space-x-4 mt-1">
                        ({assetPortfolio.componentList.map((component) => component.name).join(', ')})
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    <button
                      className="text-gray-400 hover:text-blue-500 p-2"
                      onClick={() => handleEditClick(assetPortfolio)}
                    >
                      <i className="fas fa-edit"></i>
                    </button>
                    <button
                      onClick={() => handleDeleteClick(assetPortfolio.id)}
                      className="text-gray-400 hover:text-red-500 p-2"
                    >
                      <i className="fas fa-trash-alt"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="p-6 border-t border-gray-200 bg-gray-50">
          <div className="flex justify-end">
            <button
              onClick={() => handleCloseClick()}
              className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-md text-sm !rounded-button"
            >
              닫기
            </button>
          </div>
        </div>
      </div>
      {addAssetPortfolioModalData && <AddAssetPortfolioModal {...addAssetPortfolioModalData} />}
      {editAssetPortfolioModalData && <EditAssetPortfolioModal {...editAssetPortfolioModalData} />}
    </div>
  ) : (
    <></>
  );
};

export default ManageAssetPortfolioModal;
